<template>
    <div class="search-bar">
        <div class="d-flex align-items-center">
            <label class="mr-sm-2 mb-0">Pencarian</label>
            <form class="form-inline d-flex flex-wrap">
                <div class="form-group mb-0">
                    <input type="text" style="min-width: 200px;" v-model="searchText" class="form-control" @keyup.enter="doSearch"
                        placeholder="kode..." data-lpignore="true">
                </div>
                <div class="form-group mb-0">
                    <date-picker v-model="searchDate" range type="date" placeholder="Tanggal" :editable="false" format="DD-MM-YYYY"></date-picker>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="input-group">
                    <multiselect class="w-auto flex-grow-1" v-model="searchGrade" :options="gradeOptions" :placeholder="'Pilih grade'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectGrade = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="input-group mr-1" v-if="isCreateNota">
                    <multiselect class="w-auto flex-grow-1" @input="doSearch" v-model="searchSupplier" :options="supplierOptions" :placeholder="'Pilih supplier'" :searchable="true"
                        label="name" track-by="id" :show-labels="false"></multiselect>
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button" @click="selectSupplier = true"><i class="fas fa-search"></i></button>
                    </div>
                </div>
                <div class="form-group mb-0 mr-1" v-if="!isCreateNota">
                    <multiselect v-model="searchStatus" :options="statusOptions" :placeholder="'Pilih status'" :searchable="true"
                        label="value" track-by="name" :show-labels="false"></multiselect>
                </div>
                <div class="form-group mb-0">
                    <button class="btn btn-primary" @click.prevent="doSearch">Cari</button>
                    <button class="btn btn-light mr-3" @click.prevent="resetSearch">Reset</button>
                    <button v-if="isAllowCreate" class="btn btn-primary" @click.prevent="createNota">Create Nota Supplier</button>
                </div>
            </form>
        </div>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>

        <b-modal v-model="selectGrade" size="lg" :hide-header="true" :hide-footer="true">
            <grade-selector :selected="gradeOptions" @selected="gradeSelected" @cancel="selectGrade = false"></grade-selector>
        </b-modal>

        <b-modal v-model="selectSupplier" size="lg" :hide-header="true" :hide-footer="true">
            <supplier-selector :isCreateNota="isCreateNota" :datePembayaran="isCreateNota ? searchDateParam : null" :selected="supplierOptions" @selected="supplierSelected" @cancel="selectSupplier = false"></supplier-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import GudangSelector from '../gudangs/Selector';
import GradeSelector from '../grades/Selector';
import SupplierSelector from '../suppliers/Selector';

export default {
    props: {
        isCreateNota: {
            type: Boolean,
            default: false,
        },

        isAllowCreate: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        Multiselect,
        DatePicker,
        GudangSelector,
        GradeSelector,
        SupplierSelector,
    },

    data() {
        return {
            selectGudang: false,
            searchGudang: null,
            gudangOptions: [],
            selectGrade: false,
            searchGrade: null,
            gradeOptions: [],
            selectSupplier: false,
            searchSupplier: null,
            supplierOptions: [],
            searchText: '',
            searchDate: '',
            searchStatus: '',
            statusOptions: [
                {
                    'name': 'terbayar',
                    'value': 'Terbayar',
                },
                {
                    'name': 'pending',
                    'value': 'Pending',
                },
            ],
        }
    },

    mounted() {
        this.setDefaultGudang();
    },

    computed: {
        searchDateParam() {
            return this.searchDate && this.searchDate[0] && this.searchDate[1] ? this.searchDateFormat : null;
        },
    },

    methods: {
        doSearch() {
            let self = this,
                data = {
                    searchText: self.searchText,
                    searchDate: self.searchDateParam,
                    searchGudangId: self.searchGudang ? self.searchGudang.id : '',
                    searchGradeId: self.searchGrade ? self.searchGrade.id : '',
                    searchSupplierId: self.searchSupplier ? self.searchSupplier.id : '',
                    searchStatus: self.searchStatus ? self.searchStatus.name : '',
                };
            self.$emit('search-set', data);
        },

        resetSearch() {
            this.searchText = '';
            this.searchDate = null;
            this.searchGudang = null;
            this.searchGrade = null;
            this.searchSupplier = null;
            this.searchStatus = '';
            this.setDefaultGudang();
            this.$emit('search-reset');
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.searchGudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },

        gradeSelected(grade) {
            let self = this;

            self.gradeOptions.push(grade);
            self.searchGrade = Object.assign({}, grade);
            self.selectGrade = false;
        },

        supplierSelected(supplier) {
            let self = this;

            self.supplierOptions.push(supplier);
            self.searchSupplier = Object.assign({}, supplier);
            self.$emit('supplier-selected', self.searchSupplier);
            self.selectSupplier = false;
            self.doSearch();
        },

        createNota() {
            this.$emit('create');
        },

        setDefaultGudang() {
            if (this.isCreateNota && this.userGudang) {
                this.searchGudang = Object.assign({}, this.userGudang);
            }
        },
    }
}
</script>
<style>
.search-bar {
    padding: 10px;
}
</style>
